registerComponent("sections/trajetoria", function (component) {
/**
 * 1. A entrada na rolagem (ADR 0051): título, eixo e os cartões entram
 *    escalonados quando a seção chega na tela — o mesmo padrão do resto da
 *    página, sem coreografia nova.
 * 2. O EIXO comanda os marcos: clicar num ano traz o marco dele. Como isso
 *    acontece depende da faixa (10/09, ADR 0094):
 *      · 769+ os marcos são uma PILHA e a troca é um CROSSFADE de 0,5s — a
 *        transição do site em produção, onde a linha do tempo é um `slick`
 *        com `fade: true` (o desenho e os números estão no `_trajetoria.less`,
 *        em "O DECK"). Quem entra no deck é a classe `--deck`, escrita AQUI:
 *        sem JS o trilho continua a faixa rolável de sempre.
 *      · até 768 continua a faixa rolável com encaixe, e o dedo é o gesto
 *        nativo do navegador.
 * 3. O ARRASTO troca de marco no deck, no dedo e no mouse — o mesmo contrato
 *    do carrossel do hero (ADR 0068), e o mesmo limiar.
 * 4. O estado é um ÍNDICE, e não mais só a posição do trilho: no deck não há
 *    rolagem de onde ler. No celular a posição continua sendo a verdade — o
 *    trilho é quem escreve o índice QUANDO PARA (11/09, ADR 0106: durante a
 *    rolagem a marcação ficava trocando de ano no caminho), e as duas direções
 *    caem no mesmo caminho (`ir()`).
 * 5. O EIXO ACOMPANHA: onde ele é uma faixa rolável (até 1024), o ano marcado
 *    é centrado — sem isso o ano aceso fica fora de vista depois de um arrasto
 *    e a linha do tempo parece não ter mudado. É o `asNavFor` do slick no site
 *    em produção, onde as duas faixas andam juntas.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

/* ═══════════════════════════════════════════════ o eixo e os marcos ═════ */
const trilho = component.querySelector('.trajetoria__marcos');
const caixaEixo = component.querySelector('.trajetoria__eixo-caixa');
const botoes = [...component.querySelectorAll('.trajetoria__ano-btn')];
const cartoes = [...component.querySelectorAll('.trajetoria__marco')];
const setaVoltar = component.querySelector('[data-voltar]');
const setaAvancar = component.querySelector('[data-avancar]');

if (trilho && botoes.length && botoes.length === cartoes.length) {
    const ehDeck = () => !Asa.celular.matches;

    // O marco cujo começo está mais perto do começo visível do trilho: é o
    // critério que casa com `scroll-snap-align: start`. Só vale no celular.
    const visivel = () => {
        let melhor = 0;
        let menor = Infinity;
        cartoes.forEach((cartao, i) => {
            const dist = Math.abs(cartao.offsetLeft - trilho.scrollLeft - trilho.clientLeft);
            if (dist < menor) { menor = dist; melhor = i; }
        });
        return melhor;
    };

    // O estado inicial é o que o HTML já marcou (`a.atual` nos dados).
    let atual = Math.max(0, botoes.findIndex((botao) => botao.hasAttribute('aria-current')));

    const pintar = () => {
        botoes.forEach((botao, j) => {
            const eAtual = j === atual;
            botao.closest('.trajetoria__ano').classList.toggle('trajetoria__ano--atual', eAtual);
            if (eAtual) botao.setAttribute('aria-current', 'date');
            else botao.removeAttribute('aria-current');
            cartoes[j].classList.toggle('trajetoria__marco--atual', eAtual);
        });

        /* As setas morrem nas pontas — a linha do tempo não é circular, como o
           `infinite: false` do site em produção. `disabled` e não uma classe:
           tira o botão do alcance do teclado junto. */
        if (setaVoltar) setaVoltar.disabled = atual === 0;
        if (setaAvancar) setaAvancar.disabled = atual === cartoes.length - 1;
    };

    /* CENTRA O ANO no eixo, que até 1024 é uma faixa rolável: sem isto o ano
       marcado por um arrasto (ou pela rolagem do trilho no celular) fica fora
       de vista e a linha do tempo parece não ter mudado — é o `asNavFor` do
       slick no site em produção, onde as duas faixas andam juntas.

       Pelo `scrollTo` do próprio eixo, e não por `scrollIntoView`: aquele
       também mexe na rolagem da PÁGINA quando o alvo não está inteiro na tela
       (ADR 0082), e aqui ele dispararia no meio de um gesto.

       ⚠️ A distância sai da diferença entre os `getBoundingClientRect`, e NÃO
       de `offsetLeft`: o `offsetParent` do botão é o `<li>` da coluna, não o
       eixo, então `offsetLeft` é 0 em todas as sete e o destino dava sempre
       zero. O navegador limita o destino ao fim do trilho. */
    const mostrarAno = (i) => {
        if (!caixaEixo || caixaEixo.scrollWidth <= caixaEixo.clientWidth) return;

        const botao = botoes[i].getBoundingClientRect();
        const caixa = caixaEixo.getBoundingClientRect();

        caixaEixo.scrollTo({
            left: caixaEixo.scrollLeft + botao.left - caixa.left - (caixa.width - botao.width) / 2,
            behavior: Asa.movimentoPermitido() ? 'smooth' : 'instant',
        });
    };

    const marcar = (i, metodo = 'swipe') => {
        if (i === atual) return;
        atual = i;

        // Tagueamento (plano v3.1): o marco que acendeu e como.
        Asa.track('timeline_navigate', {
            target_name: botoes[i] ? botoes[i].textContent : undefined,
            index: i,
            method: metodo,
            section: 'trajetoria',
        });
        pintar();
        mostrarAno(i);
    };

    /* A rolagem do trilho pelo próprio trilho, e NUNCA por `scrollIntoView`:
       com `block: 'nearest'` ele também mexe na rolagem da PÁGINA quando a
       seção não está inteira na tela, que é a armadilha do ADR 0082. O destino
       é a distância entre o marco e o primeiro — com marcos de largura igual e
       vão fixo, é exatamente o ponto de encaixe dele. */
    const rolarTrilho = (i, suave) => {
        trilho.scrollTo({
            left: cartoes[i].offsetLeft - cartoes[0].offsetLeft,
            behavior: suave && Asa.movimentoPermitido() ? 'smooth' : 'instant',
        });
    };

    /* O caminho único de troca: o clique no ano, o arrasto e o botão de voltar
       passam todos por aqui. O `marcar()` vem antes da rolagem para o ano
       acender sem esperar o fim da rolagem suave do celular. */
    const ir = (i, metodo = 'swipe') => {
        const destino = Math.min(cartoes.length - 1, Math.max(0, i));

        marcar(destino, metodo);

        if (!ehDeck()) rolarTrilho(destino, true);
    };

    botoes.forEach((botao, i) => {
        botao.addEventListener('click', () => ir(i, 'year'));
    });

    // As setas que flanqueiam a faixa de anos (até 1024) andam um ano.
    if (setaVoltar) setaVoltar.addEventListener('click', () => ir(atual - 1, 'arrow'));
    if (setaAvancar) setaAvancar.addEventListener('click', () => ir(atual + 1, 'arrow'));

    /* ── O ANO ACENDE QUANDO O TRILHO PARA (11/09, ADR 0106) ──────────────
       Até 768 quem manda é a rolagem do trilho, e ela marcava o ano a cada
       rajada de `scroll` (uma por quadro). Isso custava caro nos dois gestos
       que o cliente apontou como travados:
         · no CLIQUE de um ano distante, a rolagem suave do trilho passa por
           todos os marcos do caminho, e cada um deles era MARCADO: meia dúzia
           de repinturas, meia dúzia de descrições crescendo e encolhendo por
           `scale` — a tremida e a piscada do texto — e, pior, meia dúzia de
           `mostrarAno()` reapontando a rolagem suave do EIXO, que recomeçava a
           cada passo e nunca chegava (a travada);
         · no SWIPE, o vaivém do dedo em torno do meio do caminho acendia e
           apagava o mesmo par de anos, com a mesma escala e a mesma rolagem do
           eixo brigando com o gesto.
       Agora a marcação espera a rolagem PARAR: uma troca por gesto, uma
       escala, uma rolagem do eixo. É também o que o site em produção faz — o
       slick troca no `afterChange`, e não durante o arrasto. No deck o trilho
       não rola, e se rolasse a posição não seria o estado.

       `scrollend` onde existe (Chrome 114+, Firefox 109+, Safari 18.2+); onde
       não existe, o mesmo sinal pelo relógio — 120ms sem `scroll` é o fim da
       rolagem, o encaixe incluído, que continua depois de o dedo sair. */
    const aoPararTrilho = () => {
        if (!ehDeck()) marcar(visivel());
    };

    if ('onscrollend' in trilho) {
        trilho.addEventListener('scrollend', aoPararTrilho);
    } else {
        let parada = 0;

        trilho.addEventListener('scroll', () => {
            clearTimeout(parada);
            parada = setTimeout(aoPararTrilho, 120);
        }, { passive: true });
    }

    /* ─────────────────────────────────────────────────── a travessia ─────
       Entrando no deck a classe entra (e a rolagem do trilho fica órfã, mas
       ela desaparece com o `overflow`); saindo, a classe sai e o marco atual é
       levado ao começo SEM animação, senão o trilho volta mostrando o primeiro
       ano com o sétimo aceso. O eixo também se recoloca: a faixa nasce ou
       deixa de existir na travessia, e o ano aceso tem de estar à vista nos
       dois lados. A primeira chamada não rola nada: o estado inicial é o ano 0
       com o trilho e o eixo em zero. */
    let armado = false;

    const armarModo = () => {
        const deck = ehDeck();

        trilho.classList.toggle('trajetoria__marcos--deck', deck);

        if (armado) {
            if (!deck) rolarTrilho(atual, false);
            mostrarAno(atual);
        }

        armado = true;
    };

    Asa.celular.addEventListener('change', armarModo);

    /* ⚠️ O DECK ESPERA A FOLHA. As `transition` do deck moram na BASE das
       peças (o marco esmaece, a foto dá zoom, a caixa de texto sobe), e a
       folha entra sem bloquear a renderização (`media="print"` + `onload`):
       com a classe no ar antes dela, a ida "sem CSS → estado inicial" seria
       animada e os sete marcos apareceriam encolhendo e esmaecendo juntos —
       é a armadilha do ADR 0059, a mesma da entrada. O `pintar()` não espera:
       ele só acende o ano e o marco que o HTML já marcou. */
    Asa.quandoEstilizado(armarModo);
    pintar();

    /* ------------------------------------------------------------- arrasto --
       Swipe horizontal em DOIS lugares, com o mesmo contrato: nos MARCOS (só
       no deck — no celular quem cuida do gesto é a rolagem nativa do trilho) e
       na FAIXA DE ANOS onde ela não cabe na tela, que é o pedido de 10/09
       (ADR 0096): lá o `overflow` é `hidden`, o dedo não a rola mais, e cada
       gesto anda UM ano — trocando o marco, como as setas.

       É o arrasto do hero (ADR 0068) com uma diferença: aqui o conteúdo NÃO
       acompanha o dedo. É de propósito, e é o que o site em produção faz — o
       `swipeMove` do slick sai antes de mexer no trilho quando `fade` está
       ligado, então o gesto só decide a troca e a esmaecida é sempre a mesma.

       Quem separa o gesto horizontal da rolagem vertical no TOQUE é o
       `touch-action: pan-y` do CSS (nos dois alvos): o navegador fica com o
       eixo Y — a página e a lista de conquistas continuam rolando com o dedo
       por cima — e nos entrega o X. Por isso não há `preventDefault` em
       `pointermove`. A guarda de intenção (10px e |dx| > |dy|) vale para os
       dois ponteiros, e no mouse ela ainda serve para o arrasto não virar
       seleção de texto: quando o gesto se declara, `user-select: none` entra
       pela classe `--arrastando` e o que já tenha sido pintado é desmarcado.

       O limiar de troca é o do hero: 12% da largura do alvo, entre 40 e 100px.
       O teto é o que impede que 12% de um marco de 1154 virem 138px de arrasto
       para trocar.

       @param {HTMLElement} alvo    - quem escuta o gesto
       @param {string} classe      - a classe `--arrastando` dele
       @param {() => boolean} ativo - se o gesto vale agora */
    const armarArrasto = (alvo, classe, ativo) => {
        const LIMIAR = 0.12;
        const LIMIAR_MIN = 40;
        const LIMIAR_MAX = 100;

        let idPonteiro = null;
        let x0 = 0;
        let y0 = 0;
        let dx = 0;
        let horizontal = false;
        let arrastou = false;

        const soltar = () => {
            idPonteiro = null;
            horizontal = false;
            alvo.classList.remove(classe);
        };

        /* A <img> é arrastável por padrão: sem isto o mouse começa um arrasto
           nativo sobre a foto do marco e o gesto morre no primeiro pixel. */
        alvo.addEventListener('dragstart', (event) => event.preventDefault());

        alvo.addEventListener('pointerdown', (event) => {
            if (idPonteiro !== null || !ativo()) return;

            /* Só o botão principal do mouse: o direito abre o menu de contexto
               e o do meio cola/rola, e nenhum dos dois é gesto de navegação. */
            if (event.pointerType === 'mouse' && event.button !== 0) return;

            idPonteiro = event.pointerId;
            x0 = event.clientX;
            y0 = event.clientY;
            dx = 0;
            horizontal = false;
            arrastou = false;
        }, { passive: true });

        alvo.addEventListener('pointermove', (event) => {
            if (event.pointerId !== idPonteiro) return;

            dx = event.clientX - x0;

            /* Enquanto a intenção não estiver clara, não mexe em nada: um
               deslize vertical tem de continuar rolando a página (ou a lista
               de conquistas, que rola por dentro do marco). */
            if (!horizontal) {
                const dy = event.clientY - y0;

                if (Math.abs(dx) < 10 || Math.abs(dx) <= Math.abs(dy)) return;

                horizontal = true;
                arrastou = true;
                alvo.classList.add(classe);
                alvo.setPointerCapture(idPonteiro);

                const selecao = document.getSelection();

                if (selecao && !selecao.isCollapsed) selecao.removeAllRanges();
            }
        }, { passive: true });

        const terminar = (event) => {
            if (event.pointerId !== idPonteiro) return;

            const era = horizontal;
            const passo = Math.min(LIMIAR_MAX, Math.max(LIMIAR_MIN, alvo.clientWidth * LIMIAR));

            soltar();

            if (!era) return;

            // Arrastar para a esquerda avança no tempo, como no hero.
            if (dx <= -passo) ir(atual + 1);
            else if (dx >= passo) ir(atual - 1);
        };

        alvo.addEventListener('pointerup', terminar);
        alvo.addEventListener('pointercancel', terminar);

        /* Arrastar a faixa de anos não pode virar clique no ano em que o dedo
           soltou. A captura roda antes do handler do botão, e `arrastou` só é
           verdadeiro depois de o gesto ter passado do limiar de 10px. */
        alvo.addEventListener('click', (event) => {
            if (!arrastou) return;

            arrastou = false;
            event.preventDefault();
            event.stopPropagation();
        }, true);
    };

    armarArrasto(trilho, 'trajetoria__marcos--arrastando', ehDeck);

    if (caixaEixo) {
        armarArrasto(
            caixaEixo,
            'trajetoria__eixo-caixa--arrastando',
            () => caixaEixo.scrollWidth > caixaEixo.clientWidth
        );
    }
}

});
